var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.95423 0 0 8.95423 0 20C0 31.0458 8.95423 40 20 40C31.0458 40 40.0001 31.0458 40.0001 20C40 8.95423 31.0456 0 20 0ZM14.664 29.6691H10.2728V15.4824H14.664V29.6691ZM12.4474 13.6245C11.0133 13.6245 9.85071 12.4524 9.85071 11.0068C9.85071 9.56104 11.0135 8.38904 12.4474 8.38904C13.8814 8.38904 15.044 9.56104 15.044 11.0068C15.0441 12.4525 13.8815 13.6245 12.4474 13.6245ZM31.12 29.6691H26.7501V22.2222C26.7501 20.1798 25.9743 19.0397 24.3592 19.0397C22.6015 19.0397 21.6833 20.2271 21.6833 22.2222V29.6691H17.4716V15.4824H21.6833V17.3931C21.6833 17.3931 22.9502 15.0496 25.9583 15.0496C28.9666 15.0496 31.1201 16.8864 31.1201 20.6863L31.12 29.6691Z",
    fill: "url(#paint0_linear_61_1562)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_61_1562",
    x1: 5.85786,
    y1: 5.85786,
    x2: 34.1421,
    y2: 34.1421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2489BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0575B3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.5eb12d7f5edde4f1f499bf8f19fec50f.svg";
export { ForwardRef as ReactComponent };